import { render } from "./UpdateScheduleModal.vue?vue&type=template&id=35b1a167"
import script from "./UpdateScheduleModal.vue?vue&type=script&lang=js"
export * from "./UpdateScheduleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__